import React, { useState, useCallback, useEffect } from 'react'
import { Tooltip } from 'antd'
import { Input } from '@/ui'
import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import classNames from 'classnames'

import styles from './index.less'
import TextAreaModel from './components/TextAreaModel'
import SelectGoodsModel from '@/components/QueryWidgets/TextAreaModelSearchCommen/components/SelectGoodsModal'
import { splitByComma } from '@/utils/utils'

export default ({
    value,
    dataSource = {},
    onChange,
    tipTitle,
    trigger,
    className,
    triggerModelOnEnter,
    disabled = false,
    modalType = null, // 商品编码：goods  资料编码：style
    returnType, // 数据类型 csv（默认）、array
    formatValue,
    fontSize = '14px',
    ellipsisBoxClassName,
    onPressEnter,
    modalZIndex = 1000,
    ...restProps
}) => {
    const { modelTitle, tips, placeholder } = dataSource
    const [inpuVal, setInputVal] = useState(value)
    const [textAreaCtrl, setTextAreaCtrl] = useState({
        visible: false,
        data: { modelTitle, tips }
    })

    const postFormatter = useCallback(
        value => {
            if (returnType === 'array') {
                return Array.isArray(value) ? value : splitByComma(value)
            } else {
                return value
            }
        },
        [returnType]
    )

    const changeHelper = useCallback(
        value => {
            onChange && onChange(postFormatter(value))
        },
        [onChange, postFormatter]
    )

    const textAreaProps = {
        ...textAreaCtrl,
        zIndex: modalZIndex,
        onOk(value) {
            if (returnType === 'array' && Array.isArray(value)) {
                value = value.join(',')
            }
            const valueFormt =
                (value &&
                    value
                        .replace(/\n/g, ',')
                        .replace(/\，/g, ',')
                        .replace(/\,{2,}/, ',')) ||
                ''
            setInputVal(valueFormt)
            changeHelper(valueFormt)
            setTextAreaCtrl(prev => ({
                ...prev,
                visible: false
            }))
        },
        onCancel() {
            setTextAreaCtrl(prev => ({
                ...prev,
                visible: false
            }))
        }
    }

    const handleChange = useCallback(() => {
        changeHelper(inpuVal)
    }, [onChange, inpuVal])

    const handlePressEnter = useCallback(() => {
        setTextAreaCtrl(prev => ({
            ...prev,
            defaultValue: inpuVal,
            visible: true
        }))
    }, [inpuVal])

    useEffect(() => {
        setInputVal(value)
    }, [value])

    return (
        <>
            <Tooltip title={tipTitle} trigger={trigger || 'focus'} overlayStyle={{ fontSize }}>
                <Input
                    allowClear
                    value={inpuVal}
                    className={className ? classNames(styles.search, className) : styles.search}
                    onChange={({ target: { value } }) => {
                        const newVal = formatValue ? formatValue(value) : value
                        setInputVal(newVal)
                        changeHelper(newVal)
                    }}
                    {...(triggerModelOnEnter
                        ? {
                              'data-keyenterevent': true
                          }
                        : {})} // 不触发父级enter事件
                    disabled={disabled}
                    placeholder={placeholder}
                    {...restProps}
                    addonAfter={
                        <div
                            className={classNames(
                                styles.ellipsisBox,
                                'compact-query-left-placeholder',
                                {
                                    [styles.isDisabled]: disabled
                                },
                                ellipsisBoxClassName
                            )}
                            onClick={e => {
                                e.stopPropagation()
                                if (disabled) {
                                    return
                                }

                                setTextAreaCtrl({
                                    visible: true,
                                    data: { modelTitle, tips },
                                    defaultValue: inpuVal
                                })
                            }}
                        >
                            <EllipsisOutlined />
                        </div>
                    }
                    onPressEnter={triggerModelOnEnter ? handlePressEnter : onPressEnter || handleChange}
                    onBlur={handleChange}
                />
            </Tooltip>
            {modalType ? (
                <SelectGoodsModel {...textAreaProps} modalType={modalType} />
            ) : (
                <TextAreaModel formatValue={formatValue} {...textAreaProps} />
            )}
        </>
    )
}
